import { render, staticRenderFns } from "./Wordmark.vue?vue&type=template&id=1954be24&scoped=true"
import script from "./Wordmark.vue?vue&type=script&lang=js"
export * from "./Wordmark.vue?vue&type=script&lang=js"
import style0 from "./Wordmark.vue?vue&type=style&index=0&id=1954be24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954be24",
  null
  
)

export default component.exports